import fetch from 'unfetch';
import { csvParse, autoType } from 'd3-dsv';

import { trackEvent } from '~/Utils';

const loadDistributionData = async (isRel) => {
  const fileName = isRel ? 'distribution_rel' : 'distribution';
  const distributionData = await fetch(`public/data/${fileName}.csv`).then((res) => res.text());
  return csvParse(distributionData, (d, i) => {
    let size = +d['Wohnfläche'].split(',')[0].replace('(', '').replace('[', '');

    if (i === 0) {
      size = 0;
    }

    // console.log(d);
    // let income = +d.Einkommensgruppe.split('-')[0];

    // if (i === 0) {
    //   income = 0;
    // }

    // if (d.Einkommensgruppe === '>7000') {
    //   income = 7000;
    // }

    return {
      ...d,
      size,
    };
  });
};

const loadCompareData = async (isRel) => {
  const fileName = isRel ? 'compare_rel' : 'compare';
  const compareData = await fetch(`public/data/${fileName}.csv`).then((res) => res.text());
  return csvParse(compareData, autoType);
};

const loadAdditionalData = async (isRel) => {
  const fileName = isRel ? 'additional_rel' : 'additional';
  const additionalData = await fetch(`public/data/${fileName}.json`).then((res) => res.json());
  return additionalData;
};

const loadData = (Store) => async (_, isRel) => {
  Store.setState({ isLoading: true });

  let distributionData = null;
  let compareData = null;
  let additionalData = null;

  try {
    distributionData = await loadDistributionData(isRel);
    compareData = await loadCompareData(isRel);
    additionalData = await loadAdditionalData(isRel);
  } catch (err) {
    console.log(err);
  }

  // const max = isRel ? 150 : 300;
  // const householdSize = Math.min(max, Store.getState().householdSize));

  return { distributionData, compareData, additionalData, isRel, isLoading: false };
};

const setInfoboxContent = (state, infoboxContent) => {
  if (state.infoboxContent === infoboxContent) {
    return { infoboxContent: false };
  }
  return { infoboxContent };
};

const setCompareKey = (state, compareKey) => {
  trackEvent('set_group', compareKey);

  return {
    compareKey,
  };
};

const setOverallKey = (state, overallKey) => {
  trackEvent('set_group', overallKey);

  return {
    overallKey,
  };
};

const setHouseholdSize = (state, householdSize) => ({
  householdSize: Math.max(0, Math.min(householdSize, 1000)),
});

const setHouseholdMembers = (state, householdMembers) => ({
  householdMembers,
});

const setTooltipPosition = (state, tooltipX, tooltipY) => ({
  tooltipX,
  tooltipY,
});

const setTooltipVisibility = (state, tooltipVisible) => ({
  tooltipVisible,
});

const setTooltipKey = (state, tooltipKey) => ({
  tooltipKey,
});

export default (Store) => ({
  loadData: loadData(Store),
  setInfoboxContent,
  setCompareKey,
  setOverallKey,
  setHouseholdSize,
  setHouseholdMembers,
  setTooltipPosition,
  setTooltipVisibility,
  setTooltipKey,
});
